import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputSwitch } from "primereact/inputswitch";
import { Link } from 'react-router-dom';
import { FilterMatchMode } from 'primereact/api';
import { getHRStatus } from './../../assignment';
import store from '../../../../redux/store';
const OtherHelpReqs = (props) => {
    const { t } = useTranslation();
    const user = store.getState().app.user.user;
    const instPref = store.getState().app.user.more;
    const userClgs = JSON.parse(instPref.colleges);
    const userSubs = JSON.parse(instPref.subjects);
    const assignments = props.assignments.filter((hr) => (getHRStatus(hr) === "qc_passed" || getHRStatus(hr) === "received_quotes"));
    const filteredAssignments = assignments.filter((hr) => {
        if (hr.received_quotes !== 0) return false;
        const isInSubs = userSubs.includes(hr.sub_id);
        const isInClgs = userClgs.includes(hr.clg_id);
        const isPreferred = (hr.preferred_instructors || '').split(',').includes(user.id.toString());
        return isInSubs || isInClgs || isPreferred;
    });
    const filteredIds = new Set(filteredAssignments.map((hr) => hr.id));
    const remainingAssignments = assignments.filter((hr) => !filteredIds.has(hr.id));
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    return (
        <div>
            <div className="">
                <div className="d-flex jcsb">
                    <div className='mb-2'>
                        <h6>{t("all_other_gen_hrs")}</h6>
                    </div>
                </div>
                <div className="data-table mt-2">
                    <DataTable
                        value={remainingAssignments}
                        paginator
                        rows={10}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[10, 25, 50]}
                        dataKey="id"
                        selectionMode="checkbox"
                        filterDisplay="menu"
                        emptyMessage={t('data_not_available')}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        filters={filters}
                        header={
                            <div className='row'>
                                <div className="col-md-6">
                                    <input className='form-control'
                                        placeholder='Search..'
                                        onChange={(e) => {
                                            let _filters = { ...filters };
                                            _filters['global'].value = e.target.value;
                                            setFilters(_filters);
                                        }}
                                    />
                                </div>

                            </div>
                        }
                    >

                        <Column
                            field="id"
                            header={t('HR ID')}
                            sortable
                            body={(row) => {
                                return (
                                    <span>{'HR_'}{row.id}</span>
                                )
                            }}
                        />
                        <Column
                            field="hw_title"
                            header={t('Subject')}
                            sortable
                        />
                        <Column
                            field="hw_type"
                            header={t('Type')}
                            sortable
                        />
                        <Column
                            header={t('Urgent')}
                            sortField='urgent'
                            sortable
                            body={(row) => {
                                return (
                                    <InputSwitch checked={row.urgent === 1 ? true : false} />
                                )
                            }}
                        />

                        {/* <Column
                            header={"Status"}
                            body={(r) => <span><strong>{getHRStatus(r)}</strong></span>}
                        /> */}
                        <Column
                            field="due_date"
                            header={t('Due Date')}
                            sortable
                        />

                        <Column
                            header={t('actions')}
                            body={(row) => {
                                return (
                                    <div className='d-flex'>
                                        <Link
                                            to="/assignments/view"
                                            state={row.id}
                                            className='link-icon-btn mx-1' severity='info' id="edit-btn">
                                            <span className="material-symbols-outlined">
                                                visibility
                                            </span>
                                        </Link>
                                    </div>
                                )
                            }}
                        />
                    </DataTable>
                </div>
            </div>
        </div>
    );
}
export default OtherHelpReqs;